export default __webpack_public_path__ + "images/957067b5b66b5f870af6cce536f87158-fullscreen-exit.svg";